module.exports = __webpack_public_path__ + "static/media/mountain.abbd4e5c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/mountain.pdf
// module id = 355
// module chunks = 2